module.exports = __webpack_public_path__ + "images/Credit-card.aa2085dc8a7fe8ac97ca6c3f79adb31a.svg";